import { InfoBubble } from '@/components/InfoBubble';
import { Switch } from '@/components/Switch';
import { Text } from '@/components/Text';
import { cn } from '@/utils/cn';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FiLink } from 'react-icons/fi';

interface DirectLinkToggleProps {
  hasDirectLink: boolean;
  onToggle: (checked: boolean) => void;
}

export const DirectLinkToggle = ({
  hasDirectLink,
  onToggle,
}: DirectLinkToggleProps) => {
  const { t } = useTranslation();

  return (
    <motion.div
      className={cn(
        'flex w-full flex-col rounded-xl p-2 px-4 shadow-sm md:w-auto',
        hasDirectLink ? 'bg-blue-50' : 'bg-gray-50',
      )}
      initial={{ y: -10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <FiLink
            className={cn(
              'size-4',
              hasDirectLink ? 'text-linko-light' : 'text-gray-dark',
            )}
          />
          <Text
            className={cn(
              'font-medium',
              hasDirectLink ? 'text-linko-light' : 'text-gray-dark',
            )}
          >
            {t('updateCard:links.direct_link')}
          </Text>
          <InfoBubble
            message={t('updateCard:links.direct_link_description')}
            iconOnly={true}
            iconClassName="ml-1"
            tooltipClassName="bg-white"
          />
        </div>

        <Switch
          checked={hasDirectLink}
          onChange={onToggle}
          size="md"
          className="ml-4"
        />
      </div>
    </motion.div>
  );
};
